import { useQuery } from 'react-query';
import { droplrKeys } from './queryKeys';
import { BoardsResponse, CombinedBoard } from './types';
import { EXPRESS_API } from 'configs/api/expressApi';

export type GetBoardsParams = {
  userId: number;
  customerId: number;
};

export const getBoards = async (
  params: GetBoardsParams
): Promise<BoardsResponse> => {
  // fetch board details
  const covideoResponse = (
    await EXPRESS_API.get('/board/all', {
      params,
    })
  ).data;
  const covideoBoards = (covideoResponse?.boards as CombinedBoard[]) || [];

  return {
    boards: covideoBoards,
    count: covideoBoards.length,
  };
};

export const useGetBoards = (params: GetBoardsParams) => {
  return useQuery(droplrKeys.boards_list(params), () => getBoards(params));
};
